module.exports = __webpack_public_path__ + "images/psp/24Hour.webp";